module.exports = __webpack_public_path__ + "static/media/spins-bg.2ba2ff03.jpg";